// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPublicOrderDto } from './IPublicOrderDto';
import {
    IPublicOrderDtoFromJSON,
    IPublicOrderDtoFromJSONTyped,
    IPublicOrderDtoToJSON,
    IPublicOrderDtoToJSONTyped,
} from './IPublicOrderDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPagePublicOrderDto
 */
export interface IPagePublicOrderDto {
    /**
     * 
     * @type {number}
     * @memberof IPagePublicOrderDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPagePublicOrderDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPagePublicOrderDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IPublicOrderDto>}
     * @memberof IPagePublicOrderDto
     */
    content?: Array<IPublicOrderDto>;
    /**
     * 
     * @type {number}
     * @memberof IPagePublicOrderDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPagePublicOrderDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPagePublicOrderDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPagePublicOrderDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPagePublicOrderDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPagePublicOrderDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPagePublicOrderDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPagePublicOrderDto interface.
 */
export function instanceOfIPagePublicOrderDto(value: object): value is IPagePublicOrderDto {
    return true;
}

export function IPagePublicOrderDtoFromJSON(json: any): IPagePublicOrderDto {
    return IPagePublicOrderDtoFromJSONTyped(json, false);
}

export function IPagePublicOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPagePublicOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IPublicOrderDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPagePublicOrderDtoToJSON(json: any): IPagePublicOrderDto {
    return IPagePublicOrderDtoToJSONTyped(json, false);
}

export function IPagePublicOrderDtoToJSONTyped(value?: IPagePublicOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IPublicOrderDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

